export default __webpack_public_path__ + "static/media/chevron-right-solid.c3ee4024.svg";